import { Challenge } from "@/models/database/challenges/challenge.model";
import { create } from "zustand";

interface ChallengeState {
  challenges: Challenge[] | null;
  loading: boolean;
  error: Error | null;
  setChallenges: (challenges: Challenge[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: Error | null) => void;
  getChallengeBySlug: (slug: string) => Challenge | undefined;
  addChallenge: (challengeItem: Challenge) => void;
}

export const useChallengeStore = create<ChallengeState>((set, get) => ({
  challenges: null,
  loading: true,
  error: null,
  setChallenges: (challenges) => set({ challenges }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  getChallengeBySlug: (slug) => {
    const { challenges } = get();
    return challenges?.find((item) => item.slug === slug);
  },
  addChallenge: (challengeItem) => {
    const { challenges } = get();
    set({
      challenges: challenges ? [...challenges, challengeItem] : [challengeItem],
    });
  },
}));
